const state = {
  options: []
}

const mutations = {
  setOption (state, value) {
    state.options.push(value.newCost)
  },

  clearOptions (state) {
    state.options = []
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  // actions,
  // getters
}



// WEBPACK FOOTER //
// ./src/store/modules/QuoteOptions.js